export default {
  en: {
    hint: 'Search for dishes',
    summary: 'Found {products} {productsWord} in {restaurants} {restaurantsWord}',
    productsWord: 'result | results',
    restaurantsWord: 'restaurant | restaurants',
  },
  ru: {
    hint: 'Ищите блюда',
    summary: 'Найдено {products} {productsWord} в {restaurants} {restaurantsWord}',
    productsWord: 'результатов | результат | результата | результатов',
    restaurantsWord: 'ресторанах | ресторане | ресторанах | ресторанах',
  },
}
